<template>
  <div>
    <v-tabs v-model="tab" vertical>
      <v-tab key="General">{{$t("general")}}</v-tab>
      <v-tab key="Stages">{{$t("entities.version.tabs.form.stages")}}</v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item key="General">
          <v-form v-model="valid" ref="form">
            <v-text-field
              v-model="value.code"
              :label="$t('entities.version.props.code')"
              :rules="$isRequiredRule"
            ></v-text-field>
            <v-text-field
              v-model="value.description"
              :label="$t('entities.version.props.description')"
              :rules="$isRequiredRule"
            ></v-text-field>
          </v-form>
        </v-tab-item>
        <v-tab-item key="Stages" eager>
          <stageTabItem v-model="value" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import stageTabItem from "./stageTabItem";
export default {
  components: { stageTabItem },
  props: {
    value: {
      default() {
        return {
          code: "",
          description: "",
          stages: []
        };
      }
    }
  },
  watch: {
    value() {
      this.$refs.form.resetValidation();
    }
  },
  data() {
    return {
      valid: true,
      resources: [],
      stageTypes: [],
      tab: null
    };
  },

  methods: {
    isValid() {
      return this.$refs.form.validate();
    }
  },
  async mounted() {}
};
</script>